import { ListBulletIcon } from '@interstate/components/Icons/ListBulletIcon';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';
import { Typography } from '@interstate/components/Typography';
import rem from 'polished/lib/helpers/rem';
import React, { type CSSProperties } from 'react';
import MileageCostOptionsSlideOut from '../../mileageCostOptions/MileageCostOptionsSlideOut.interstate';
import { OptionsButton } from './CustomMileageField.style';
import { useCustomMileageNumericField } from './hooks/useCustomMileageNumericField';

const dealerDiscountContainerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: '17px',
    justifyContent: 'space-between',
    marginBottom: rem(6)
};

const CustomMileageFieldNumeric = () => {
    const {
        label,
        isLocked,
        hasOptions: enableLeaseContractField,
        isSlideOutOpen: slideOut,
        toggleSlideOut,
        inputProps
    } = useCustomMileageNumericField();

    return (
        <div>
            {enableLeaseContractField && (
                <div
                    style={dealerDiscountContainerStyle}
                    data-testid="custom-mileage-label"
                    className="base-deal-activity-control-custom-label"
                >
                    <Typography variant={'body-xs'} color="#6d6d6d" sx={{ cursor: 'default', userSelect: 'none' }}>
                        {label}
                    </Typography>
                    <OptionsButton
                        onClick={toggleSlideOut}
                        onKeyDown={(e: React.KeyboardEvent) => {
                            if (!isLocked && (e.key === 'Enter' || e.key === ' ')) {
                                e.preventDefault();
                                toggleSlideOut();
                            }
                        }}
                        component={'button'}
                        data-testid="custom-mileage-options-button"
                        {...(!isLocked && { tabIndex: 0, role: 'button' })}
                        {...(isLocked && { disabled: true, className: 'disabled-button' })}
                    >
                        <ListBulletIcon aria-label="Dealer Discount" />
                        <Typography variant={'body-xs'}>Options</Typography>
                    </OptionsButton>
                </div>
            )}

            <NumericInput
                {...inputProps}
                displayLabel={!enableLeaseContractField}
                label={!enableLeaseContractField ? label : undefined}
            />

            {slideOut && <MileageCostOptionsSlideOut show={slideOut} onHide={toggleSlideOut} />}
        </div>
    );
};

export default CustomMileageFieldNumeric;
